import Cookies from 'js-cookie';

import { defaultLocale, DisplayLanguage } from '@app/services/translations';

import { DISPLAY_LANGUAGE_COOKIE_NAME } from '../../locale';

export function getDisplayLanguageCookie(): string | undefined {
  return Cookies.get(DISPLAY_LANGUAGE_COOKIE_NAME);
}

export function computeDisplayLanguage(cookieValue: DisplayLanguage | undefined): DisplayLanguage {
  return cookieValue || defaultLocale.displayLanguage;
}
